import * as React from 'react';
import { Tooltip } from 'antd';
import humanizeUtil from '@utils/humanizeUtil';
import { getMetricUnitByKey } from '@utils/metrics';
import Trend from './Trend';
import * as Styled from '../styled';
import type { TrendProps } from './Trend';

export interface MetricTrendProps extends Omit<TrendProps, 'metricKey'> {
  metricKey?: string;
  name: string;
  unit?: string;
  description?: string;
  total?: number | null;
  placeholder?: React.ReactNode;
  chartStyle?: React.CSSProperties;
}

const MetricTrend = (props: MetricTrendProps) => {
  const {
    metricKey,
    total,
    data,
    name,
    description,
    unit = metricKey ? getMetricUnitByKey({ metricKey }) : undefined,
    placeholder,
    chartStyle,
  } = props;

  const { humanizedNumber, humanizedUnit } = metricKey
    ? humanizeUtil(total, metricKey, unit)
    : { humanizedNumber: '', humanizedUnit: '' };

  return (
    <>
      <Styled.Title>
        <Tooltip title={description}>{name}</Tooltip>
      </Styled.Title>
      {metricKey ? (
        <>
          <Styled.Value>
            {humanizedNumber} {humanizedUnit}
          </Styled.Value>
          <Trend metricKey={metricKey} data={data} style={chartStyle} />
        </>
      ) : (
        placeholder
      )}
    </>
  );
};

export default React.memo(MetricTrend);
